import type { AdPartnerLevelAttributionSettings } from '../../../../../shared/types/attributionSettingsTypes';

const { extend_conversion_event_window_days_limits } = window.App.context.flipper || {};
export const SNAP_HUMAN_READABLE = 'Snap';
export const FACEBOOK_HUMAN_READABLE = 'Facebook';
export const TWITTER_HUMAN_READABLE = 'Twitter';
export { UNNAMED_PARTNER } from '../../../common/support/adPartnerConstants';
export const PARTNER_MAX_ATTRIBUTION_WINDOWS: Partial<AdPartnerLevelAttributionSettings> = {
  impression_session_start_window_days: 30,
  impression_install_window_days: 30,
  impression_conversion_event_window_days: extend_conversion_event_window_days_limits ? 90 : 30,
};
export const FACEBOOK_MAX_ATTRIBUTION_WINDOWS: Partial<AdPartnerLevelAttributionSettings> = {
  click_session_start_window_days: 45,
  click_install_window_days: 45,
  click_conversion_event_window_days: extend_conversion_event_window_days_limits ? 90 : 45,
};
export const TWITTER_MAX_ATTRIBUTION_WINDOWS: Partial<AdPartnerLevelAttributionSettings> = {
  click_session_start_window_days: 30,
  click_install_window_days: 30,
  click_conversion_event_window_days: extend_conversion_event_window_days_limits ? 90 : 30,
  impression_session_start_window_days: 30,
  impression_install_window_days: 30,
  impression_conversion_event_window_days: extend_conversion_event_window_days_limits ? 90 : 30,
};
export const SNAP_MAX_ATTRIBUTION_WINDOWS: Partial<AdPartnerLevelAttributionSettings> = {
  click_session_start_window_days: 28,
  click_install_window_days: 28,
  click_conversion_event_window_days: extend_conversion_event_window_days_limits ? 90 : 28,
  impression_session_start_window_days: 1,
  impression_install_window_days: 1,
  impression_conversion_event_window_days: extend_conversion_event_window_days_limits ? 90 : 30,
};
export const SNAP_DEFAULT_ATTRIBUTION_WINDOWS: Partial<AdPartnerLevelAttributionSettings> = {
  click_session_start_window_days: 28,
  click_install_window_days: 7,
  click_conversion_event_window_days: 1,
  impression_session_start_window_days: 1,
  impression_install_window_days: 1,
  impression_conversion_event_window_days: 1,
};
export const ATTRIBUTION_SETTINGS_TEXT = {
  TOGGLE_TITLE: 'Use ad partner attribution settings',
  getToggleTooltip: (company_name: string): string =>
    `Use a custom attribution window to match ${company_name}'s attribution windows. This overrides your app level attribution windows.`,
  INSTALL_ATTR_CHECKBOX_LABEL: 'Only attribute based on install touch',
  INSTALL_ATTR_CHECKBOX_SUBTEXT:
    'When this is checked, we will only attribute events for this partner based on the touch (click or impression) that drove the install. This is useful for ad partners that are only used for acquisition campaigns, and essentially disables "re-engagement" attribution. Other attribution windows (for example, click to conversion) still apply to the install touch.',
};
export const INSTALL_ATTR_DB_PROPERTY = 'install_touch_attribution';
export const LIMITED_DATA_USE = 'LDU';
export const SNAP_ENABLE_ADVANCED_CONVERSION_DB_PROPERTY = 'ios_user_data_send_enabled';
export const SNAP_ADVANCED_CONVERSION_GUIDE_LINK =
  'https://businesshelp.snapchat.com/s/article/advanced-conversions?language=en_US';
export const FACEBOOK_PLAY_STORE_REFERRER_KEY = 'fb_playstore_referrer_key';
export const FACEBOOK_ENABLE_AGGREGATED_MEASUREMENT_KEY = 'enable_aggregated_event_measurement';
export const FACEBOOK_LIMITED_DATA_OPTIONS_KEY = 'limited_data_options';
export const AD_PARTNER_SCREEN_TAB_ACCOUNT_SETTINGS = 'Account Settings';
export const AD_PARTNER_SCREEN_TAB_EVENTS_CONFIG = 'Events Config';
export const AD_PARTNER_SCREEN_TAB_ATTRIBUTION_WINDOWS = 'Attribution Windows';

export const COST_DATA = 'Cost Data';

export const LOG_SEARCH_DEBOUNCE_TIME = 750;

export const INVALID_TOKEN_STATUS = 'invalid_token';
export const PENDING_REQUEST_STATUS = 'pending_request';
export const SUCCESS_STATUS = 'success';
export const PARTNER_ERROR_STATUS = 'partner_error';
export const DATA_UNAVAILABLE_STATUS = 'data_unavailable';
export const STATUS_UNAVAILABLE = 'status_unavailable';

export const AD_PARTNER_NO_CONNECTION_IMAGE = '/static/images/ad_partner_manager/ad_partner_no_connection.svg';
